import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";

import {HttpCommonService} from "../services/http-common.service";
import {NzMessageService} from "ng-zorro-antd";
import {Injectable} from "@angular/core";
import {GlobalService} from "../services/global.service";

@Injectable()
export class PersonGuard implements CanActivate{

  constructor(private msg: NzMessageService,
              public http: HttpCommonService,
              private globalService: GlobalService,
              private router: Router){}

  canActivate(routerInfo: ActivatedRouteSnapshot, state: RouterStateSnapshot){
    let routeUrl = routerInfo.url[0].path;
    let queryType  = routerInfo.queryParams["type"];
    // 企业入驻，type为1不需要登录，2和3需要登陆
    if (routeUrl == "registerEnterp" && queryType == "1") {
      return true;
    } else {
      return this.http.get("/auth/jwt/isLogin").map((result)=>{
        // 已登录
        if (result.stateCode == '20111') {
          if (result.data.userType == 'person') {
            return true;
          } else {
            this.msg.error("请登录个人账号");
            this.router.navigate(["comLR/login"]);
            return false;
          }
        } else if (result.stateCode == '40500') {
          // 不同用户登录同一账号密码被修改时
          return true;
        } else {
          if (this.globalService.isLoginedUser) {
            this.msg.error("您的账号已超时，请重新登录");

            // 设置未读消息不显示
            this.globalService.setKey("countShow", false);

            this.globalService.isLoginedUser = false;
            this.router.navigate(["comLR/login"]);
          } else {
            this.msg.error("请登录个人账号");
            this.router.navigate(["comLR/login"]);
          }
          return false;
        }
      }).first();
    }
  }


}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/guard/PersonGuard.ts